// app/javascript/compcalc/components/utils/ButtonFlip.jsx

import React from 'react';

import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

import ReactCardFlip from './ReactCardFlip';
// import ReactCardFlip from 'react-card-flip';


const styles = theme => ({
  noTransform: {
    textTransform: 'none',
  },
  noBackFace: {
    backfaceVisibility: 'hidden',
    WebkitBackfaceVisibility: 'hidden',
    transform: 'scale(1)',
    WebkitTransform: 'scale(1)',
    width: '100%',
    // flexGrow: '1',
    // background: 'green',
    // display: 'inline',
  },
});


// props.isFlipped = true/false, props.text, props.onButtonPressed
class ButtonFlip extends React.PureComponent {

  render() {
    // console.log("ButtonFlip.render()");

    let { classes } = this.props;
    let { flipSpeed } = this.props;
    let flipHalfSpeed = flipSpeed ? flipSpeed / 2000.0 : 0.8;

    if (this.props.useFlip) {
      return (
        <ReactCardFlip flipSpeedBackToFront={flipHalfSpeed} flipSpeedFrontToBack={flipHalfSpeed} isFlipped={this.props.isFlipped}>
          <div key="front" className={classes.noBackFace}>
            <Button color="primary" variant="contained" size="medium" onClick={this.props.onClick} className={classes.noTransform}>
            {
              this.props.text
            }
            </Button>
          </div>
          <div key="back" className={classes.noBackFace}>
            {
              this.props.children
            }
          </div>
        </ReactCardFlip>
      );
    }
    else {
      return (
        <div>
        {
          this.props.children
        }
        </div>
      );
    }
  }

};

export default withStyles(styles)(ButtonFlip);
